import React, { useContext } from "react";
import {
  SimilarResultsContainer,
  MainContent,
  ContentHeader,
  ContentTitle,
  ResultsList,
  ResultItem,
  ProfileImage,
  CitizenDetailsSection,
  DetailValue,
  BottomAction,
  NotYouText,
  NewRegistrationButton,
  VerificationSection,
  VerificationQuestion,
  ContinueButton,
  StyledHR,
} from "../similarResults/SimilarResults.styled";
import { NewCitizenContext } from "../../pages/Register/Form/NewCitizenContext";
import moment from "moment";
import { getCitizen } from "services/citizen";

const SimilarResults = () => {
  const { state, stateDispatchMain, handleSimilarCitizenSelect, handleNewRegistration } = useContext(NewCitizenContext);

  const handleCitizenClick = async citizen => {
    // Update citizen details and navigate to Verification
    stateDispatchMain({
      key: "isHidden",
      payload: false,
    });

    const citizenDetails = await getCitizen(citizen.card_number);

    handleSimilarCitizenSelect(citizenDetails);
  };

  const handleNewRegistrationClick = () => {
    stateDispatchMain({
      key: "isHidden",
      payload: false,
    });

    handleNewRegistration();
  };

  const formatBirthdate = birth_date => {
    if (!birth_date) return "";
    return moment(birth_date).format("MMM D, YYYY");
  };

  const getProfileImage = citizen => {
    if (citizen.profile) {
      return citizen.profile;
    }
    return null;
  };

  const citizen = state.similarCitizens?.[0] || null;
  const citizenCount = citizen ? 1 : 0;

  return (
    <SimilarResultsContainer>
      <MainContent>
        <ContentHeader>
          <ContentTitle>
            We&apos;ve found{" "}
            <strong>
              {citizenCount} person{citizenCount !== 1 ? "s" : ""}
            </strong>{" "}
            that matches the information
          </ContentTitle>
        </ContentHeader>

        <ResultsList>
          {citizen && (
            <ResultItem>
              <ProfileImage>
                {getProfileImage(citizen) ? <img src={getProfileImage(citizen)} alt="Profile" /> : <span>👤</span>}
              </ProfileImage>
              <CitizenDetailsSection>
                <DetailValue>{citizen.card_number || ""}</DetailValue>
                <DetailValue>{citizen.full_name || ""}</DetailValue>
                <DetailValue>
                  <strong>{formatBirthdate(citizen.birth_date)}</strong>
                </DetailValue>
              </CitizenDetailsSection>
            </ResultItem>
          )}
        </ResultsList>

        <VerificationSection>
          <VerificationQuestion>
            <span>Are you this person?</span>
            <ContinueButton onClick={() => citizen && handleCitizenClick(citizen)}>Continue →</ContinueButton>
          </VerificationQuestion>
        </VerificationSection>

        <StyledHR />

        <VerificationSection>
          <BottomAction>
            <NotYouText>Not you?</NotYouText>
            <NewRegistrationButton onClick={handleNewRegistrationClick}>New Registration</NewRegistrationButton>
          </BottomAction>
        </VerificationSection>
      </MainContent>
    </SimilarResultsContainer>
  );
};

export default SimilarResults;
